import React from 'react';
import SearchSection from '../SearchSection/SearchSection';
import { HeroSectionProps } from './HeroSection.type';
import './HeroSection.styles.scss';

const HeroSection: React.FC<HeroSectionProps> = ({ suggestions }) => {
  return (
    <section className="hero-section">
      <div className="container">
        <div className="hero-content text-center">
          {/* <h1 className="hero-title">Product WIKI</h1> */}
          <p className="hero-subtitle">
            Your comprehensive platform for market opportunities, competitive intelligence, and
            regulatory insights across the pharmaceutical landscape
          </p>
          <SearchSection suggestions={suggestions} />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
